<script setup lang="ts">
const {isLoggedIn} = useAuthStore();
</script>

<template>
  <div class="fixed bottom-0 left-0 right-0 h-[48px] bg-gray-light backdrop-blur-xl z-50">
    <NavigationList v-if="isLoggedIn"/>
  </div>
</template>
